import styled from 'styled-components'

export const Description = styled.div`
  margin-bottom: 16px;
  line-height: 150%;
`
